import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WorkoutSummary = ({ workouts, onViewPrograms }) => {
  const getTotalWorkouts = () => {
    return workouts?.reduce((sum, workout) => sum + workout?.sessionsCompleted, 0);
  };

  const getTotalDuration = () => {
    return workouts?.reduce((sum, workout) => sum + workout?.totalMinutes, 0);
  };

  const getCaloriesBurned = () => {
    return workouts?.reduce((sum, workout) => sum + workout?.caloriesBurned, 0);
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center">
            <Icon name="Dumbbell" size={20} color="var(--color-success)" />
          </div>
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            Workout Summary
          </h2>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="ArrowRight"
          iconPosition="right"
          onClick={onViewPrograms}
        >
          View All
        </Button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <div className="p-4 rounded-lg bg-primary/5 border border-primary/20">
          <div className="flex items-center gap-3 mb-2">
            <Icon name="Activity" size={20} color="var(--color-primary)" />
            <span className="text-sm text-muted-foreground">This Month</span>
          </div>
          <p className="text-2xl md:text-3xl font-heading font-bold text-foreground data-text">
            {getTotalWorkouts()}
          </p>
          <p className="text-xs text-muted-foreground mt-1">Workouts completed</p>
        </div>

        <div className="p-4 rounded-lg bg-accent/5 border border-accent/20">
          <div className="flex items-center gap-3 mb-2">
            <Icon name="Clock" size={20} color="var(--color-accent)" />
            <span className="text-sm text-muted-foreground">Total Time</span>
          </div>
          <p className="text-2xl md:text-3xl font-heading font-bold text-foreground data-text">
            {getTotalDuration()}
          </p>
          <p className="text-xs text-muted-foreground mt-1">Minutes trained</p>
        </div>

        <div className="p-4 rounded-lg bg-success/5 border border-success/20 sm:col-span-3 lg:col-span-1">
          <div className="flex items-center gap-3 mb-2">
            <Icon name="Flame" size={20} color="var(--color-success)" />
            <span className="text-sm text-muted-foreground">Calories</span>
          </div>
          <p className="text-2xl md:text-3xl font-heading font-bold text-foreground data-text">
            {getCaloriesBurned()?.toLocaleString()}
          </p>
          <p className="text-xs text-muted-foreground mt-1">Calories burned</p>
        </div>
      </div>
      <div className="space-y-3">
        <h3 className="text-sm font-medium text-foreground mb-3">Recent Programs</h3>
        {workouts?.map((workout) => {
          const progressPercent = (workout?.sessionsCompleted / workout?.totalSessions) * 100;
          
          return (
            <div
              key={workout?.id}
              className="p-4 rounded-lg border border-border hover:border-primary/50 transition-all duration-250"
            >
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h4 className="text-base font-medium text-foreground mb-1">
                    {workout?.name}
                  </h4>
                  <p className="text-sm text-muted-foreground">
                    {workout?.sessionsCompleted} of {workout?.totalSessions} sessions
                  </p>
                </div>
                <span className="badge-success">
                  {Math.round(progressPercent)}%
                </span>
              </div>
              <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full bg-success transition-all duration-500"
                  style={{ width: `${progressPercent}%` }}
                />
              </div>
              <div className="flex items-center gap-4 mt-3 text-xs text-muted-foreground">
                <span className="flex items-center gap-1">
                  <Icon name="Target" size={12} />
                  {workout?.goal}
                </span>
                <span className="flex items-center gap-1">
                  <Icon name="TrendingUp" size={12} />
                  {workout?.difficulty}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WorkoutSummary;